import { Typography, TypographyProps } from "@kaltura/ds-react-components";

// lock the component to h1, regardless of variant
// the intermediate component is to prevent ts from complaining of the missing `component` prop
export const TypographyComponent = (props: TypographyProps<"h1">) => {
    return <Typography {...props} component={"h1"} />;
}
